interface BulbIconProps {
    size?: number;
    color?: string;
}

export function BulbIcon({ size = 16, color = "currentColor" }: BulbIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.1"
                d="M12 3.1875C8.68594 3.1875 6 5.87344 6 9.1875C6 11.3555 7.15781 13.3195 9.00234 14.3859L9.84375 14.8734V17.625H14.1562V14.8734L14.9977 14.3859C16.8422 13.3195 18 11.3555 18 9.1875C18 5.87344 15.3141 3.1875 12 3.1875Z"
                fill={color}
            />
            <path
                d="M14.8125 20.8125H9.1875C9.08437 20.8125 9 20.8969 9 21V21.75C9 22.1648 9.33516 22.5 9.75 22.5H14.25C14.6648 22.5 15 22.1648 15 21.75V21C15 20.8969 14.9156 20.8125 14.8125 20.8125ZM12 1.5C7.75547 1.5 4.3125 4.94297 4.3125 9.1875C4.3125 12.0328 5.85938 14.5172 8.15625 15.8461V18.5625C8.15625 18.9773 8.49141 19.3125 8.90625 19.3125H15.0938C15.5086 19.3125 15.8438 18.9773 15.8438 18.5625V15.8461C18.1406 14.5172 19.6875 12.0328 19.6875 9.1875C19.6875 4.94297 16.2445 1.5 12 1.5ZM14.9977 14.3859L14.1562 14.8734V17.625H9.84375V14.8734L9.00234 14.3859C7.15781 13.3195 6 11.3555 6 9.1875C6 5.87344 8.68594 3.1875 12 3.1875C15.3141 3.1875 18 5.87344 18 9.1875C18 11.3555 16.8422 13.3195 14.9977 14.3859Z"
                fill={color}
            />
        </svg>
    );
}
